import { StyledImage } from '../../Atoms/Image/styles'
import { StyledSVG } from '../../Atoms/SVG/styles'
import { StyledCard } from '../../Molecules/Card/styles'
import { fadeIn, scaleUp } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'

export const StyledNextTime = styled('div', {
    alignContent: 'center',
    display: 'grid',
    justifyItems: 'center',
    p: '$2',
    size: '100%',
    transition: '$default',

    '@mobile': {
        borderLeft: '1px solid',
    },

    '@desktop': {
        borderTop: '1px solid',
    },

    variants: {
        backgroundWhite: {
            true: {
                bc: '$neutral300',
                bgc: '$neutral50',
            },
            false: {
                bc: '$primary300',
                bgc: '$primary300',
            },
        },
    },
})

export const CloseIcon = styled('div', {
    ...createAnimation([fadeIn, scaleUp]),
    color: '$primary600',
    position: 'absolute',
    right: 8,
    top: 8,
})

export const PartnerInfo = styled('div', {
    display: 'grid',

    '@desktop': {
        justifyItems: 'center',
        px: '$3',
        textAlign: 'center',
    },
})

export const PartnerImage = styled('div', {
    display: 'flex',
    placeSelf: 'center',

    [`& ${StyledImage}, ${StyledSVG}`]: {
        placeSelf: 'center',
    },

    [`& ${StyledImage}`]: {
        br: '50%',
    },

    [`& ${StyledSVG}`]: {
        h: '100%',
    },

    '@mobile': {
        py: '$2',
        pl: '$2',
    },

    '@desktop': {
        maxW: 125,
        mt: '$3',
    },
})

export const StyledPartnerCard = styled(StyledCard, {
    bc: 'transparent',
    bgc: '$neutral50',
    position: 'relative',

    '&:hover': {
        bc: '$primary600',

        [`& ${StyledNextTime}`]: {
            bc: '$primary600',
        },
    },

    '@mobile': {
        gap: '$2',
        gridAutoFlow: 'column',
        gridTemplateColumns: '80px 1fr 100px',
        justifyItems: 'start',
    },

    '@desktop': {
        gap: '$3',
    },

    variants: {
        isSelected: {
            true: {
                bc: '$primary600',
                boxShadow: '$default',

                [`& ${StyledNextTime}`]: {
                    bc: '$primary600',
                    bgc: '$primary600',
                    color: '$white',
                },
            },
        },
    },

    defaultVariants: { isSelected: false },
})
